import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth.guard';
import { inventaireSessionGuard } from './core/auth/inventaire-session.guard';

export const routes: Routes = [
  {
    path: 'qr-scan',
    loadComponent: () =>
      import('./features/qr-scan/qr-scan.page').then((m) => m.QrScanPage),
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./features/login/login.page').then((m) => m.LoginPage),
  },
  {
    path: 'portal',
    loadComponent: () =>
      import('./features/portal/portal.page').then((m) => m.PortalPage),
    canActivate: [authGuard],
  },
  {
    path: 'inventaire',
    loadComponent: () =>
      import('./features/inventaire/inventaire.page').then(
        (m) => m.InventairePage
      ),
    canActivate: [authGuard, inventaireSessionGuard],
  },
  {
    path: 'scanner',
    loadComponent: () =>
      import('./features/barcode-scan/barcode-scan.page').then(
        (m) => m.BarcodeScanPage
      ),
    canActivate: [authGuard],
  },
  {
    path: 'catalogue',
    loadComponent: () =>
      import('./features/catalog/catalog.page').then((m) => m.CatalogPage),
    canActivate: [authGuard],
  },
  {
    path: 'submit',
    loadComponent: () =>
      import('./features/submit/submit.page').then((m) => m.SubmitPage),
    canActivate: [authGuard],
  },
  {
    path: '',
    redirectTo: 'portal',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: 'portal',
  },
];
